<template>
  <v-card class="mt-4">
    <v-progress-linear :active="loading" class="ma-0" color="cyan accent-3" height="16" indeterminate>Carregando suas assinaturas...</v-progress-linear>
    <div v-if="$route.path.includes('assinaturas') || assinaturas.length">
      <v-card-title> <strong>Minhas assinaturas</strong><br /> </v-card-title>
      <v-card-text>
        <v-divider></v-divider>
        <v-flex xs12>
          <span v-if="!$route.path.includes('assinaturas') && assinaturas.length" class="font-italic blue--text">Você já possui as assinaturas:</span>
          <span v-if="semAssinaturas" class="font-italic red--text"
            >Você ainda não possui assinaturas.
            <span v-if="$store.state.site.paywall">
              <span class="black--text"> Para adquirir uma assinatura, </span>
              <router-link to="/assine">
                <a href="#">clique aqui</a>
              </router-link>
            </span>
          </span>
        </v-flex>
        <v-divider class="mb-2"></v-divider>

        <v-data-iterator :items="assinaturas" hide-default-footer no-data-text class="text-center" :items-per-page="100">
          <template v-slot:default="props">
            <v-row>
              <v-col v-for="item in props.items" :key="item.id" cols="12">
                <v-card class="mx-auto text-left" max-width="660">
                  <v-layout>
                    <v-flex
                      xs3
                      class="text-center justify-center pt-2"
                      :style="
                        'background-color:' +
                        (item.status == 'CORRENTE'
                          ? 'green'
                          : item.status == 'PENDENTE'
                          ? 'darkorange'
                          : item.status == 'SUSPENSA'
                          ? 'darkgreen'
                          : item.status == 'EXPIRADA'
                          ? 'orangered'
                          : 'darkred')
                      "
                    >
                      <v-icon size="80" color="white">{{
                        item.status == "CORRENTE"
                          ? "check_circle"
                          : item.status == "PENDENTE"
                          ? "info"
                          : item.status == "SUSPENSA"
                          ? "hourglass_empty"
                          : item.status == "EXPIRADA"
                          ? "dangerous"
                          : "highlight_off"
                      }}</v-icon>

                      <h2 v-if="$vuetify.breakpoint.mdAndUp" style="color: white">Assinatura {{ item.status }}</h2>

                      <p v-if="$vuetify.breakpoint.xs">
                        <strong>{{ item.status }}</strong>
                      </p>

                      <v-btn
                        v-if="$store.state.site.assinante && item.cancelar && item.status != 'CANCELADA'"
                        class="mt-2"
                        x-small
                        outlined
                        style="color: white"
                        @click="cancela(item)"
                        >Cancelar</v-btn
                      ><!-- se permite degustação, tem que permitir cancelar (dentro do período da degustação) -->

                      <router-link :to="'/ativar/' + item.id">
                        <v-btn v-if="['PENDENTE'].includes(item.status)" class="mt-2" x-small outlined style="color: white">Ativar</v-btn> </router-link
                      ><!-- se permite captação, tem que permitir ativar (passar cartão) -->

                      <v-btn
                        v-if="
                          $store.state.site.assinante &&
                          $store.state.site.reativarExpirada &&
                          ['EXPIRADA'].includes(item.status) &&
                          item.vlrLiquido &&
                          item.degustacao == 0 &&
                          !isCortesia(item)
                        "
                        class="mt-2"
                        x-small
                        outlined
                        style="color: white"
                        @click="reativa(item)"
                        >Reativar</v-btn
                      >

                      <!-- v-btn v-if="['CANCELADA'].includes(item.status)" class="mt-2" x-small outlined style="color: white" @click="dialogOK = true">Reativar</v-btn -->

                      <v-btn
                        v-if="$store.state.site.assinante && $store.state.site.finalizarSuspensao && item.status == 'SUSPENSA' && new Date(item.dtSuspensao) > new Date()"
                        class="mt-2"
                        x-small
                        outlined
                        style="color: white"
                        @click="finalizarSuspensao(item)"
                        >Reativar</v-btn
                      >

                      <v-btn
                        v-if="$store.state.site.assinante && $store.state.site.incluirSuspensao && item.status == 'CORRENTE' && item.degustacao == 0"
                        class="mt-2"
                        x-small
                        outlined
                        style="color: white"
                        @click="suspende(item)"
                        >Suspender</v-btn
                      >
                    </v-flex>

                    <v-flex xs9 class="ml-4 mb-2" style="min-height: 160px">
                      <h2 class="dadoCampo mt-2">Código</h2>
                      <h2 class="dadoValor">{{ item.id }}</h2>

                      <h2 class="dadoCampo mt-2">Plano</h2>
                      <h2 class="dadoValor">{{ item.plano }}</h2>

                      <div v-if="item.dtCancelamento && item.status != 'CANCELADA'">
                        <h2 class="dadoCampo mt-2"><span style="color: blue">Cancelamento agendado para</span></h2>
                        <h2 class="dadoValor">
                          {{ formatDate(item.dtCancelamento) }}
                        </h2>
                      </div>
                      <div v-else>
                        <h2 class="dadoCampo mt-2">
                          {{
                            item.status == "CORRENTE"
                              ? item.renovacaoAutomatica
                                ? "Renovação Automática em"
                                : "Expira em"
                              : item.status == "SUSPENSA"
                              ? "Suspensa até"
                              : item.status == "EXPIRADA"
                              ? parseDateUS(item.dtFim) < new Date()
                                ? "Expirada desde"
                                : ""
                              : item.status == "CANCELADA"
                              ? "Cancelada em"
                              : "Assinatura em análise"
                          }}
                        </h2>
                        <h2 class="dadoValor" v-if="item.status != 'PENDENTE'">
                          {{
                            item.status == "SUSPENSA"
                              ? formatDate(item.dtSuspensao)
                              : item.status == "CANCELADA"
                              ? formatDate(item.dtCancelamento)
                              : item.status == "EXPIRADA"
                              ? parseDateUS(item.dtFim) < new Date()
                                ? formatDate(item.dtFim)
                                : ""
                              : formatDate(item.dtFim)
                          }}
                        </h2>
                      </div>

                      <h2 v-if="item.degustacao > 0" class="dadoValor mt-2" style="color: blue">Assinatura em período de degustação</h2>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>

        <v-flex xs12>
          <v-sheet class="mt-4 ml-1 red--text" :value="true" v-if="mensagemErro">{{ mensagemErro }}</v-sheet>
        </v-flex>
      </v-card-text>
    </div>
    <v-dialog v-model="dialogOK" max-width="290">
      <v-card>
        <v-toolbar>
          <span class="headline">Aguarde...</span>
        </v-toolbar>
        <v-card-text style="font-weight: bold"><br />Em breve esta funcionalidade estará disponível!</v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="dialogOK = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogConfirm" max-width="290">
      <v-card>
        <v-toolbar>
          <span class="headline">Confirmação</span>
        </v-toolbar>
        <v-card-text style="font-weight: bold"
          ><br />
          <h3 v-html="msgConfirm"></h3
        ></v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="confirmado">Sim</v-btn>
          <v-btn color="primary" text @click="naoConfirmado">Não</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogSuspender" max-width="600">
      <v-card>
        <v-toolbar>
          <span class="headline">Suspensão</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogSuspender = false">
            <v-icon color="darken-1">cancel</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form ref="formSuspensao" v-model="suspensaoValid" lazy-validation>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 md6>
                  <v-menu v-model="mnDtInicioSuspensao" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        autofocus
                        v-model="dtInicioSuspensao"
                        label="Data de Início"
                        v-mask="'##/##/####'"
                        prepend-icon="event"
                        v-on="on"
                        hint="Obrigatório"
                        :rules="[
                          validacao.suspensao_dtInicio == false || validacao.suspensao_dtInicio,
                          (value) => valida_data_futura(value) || 'Data inválida ou edição já fechada',
                          (value) => !!value || 'Obrigatório.',
                          (value) => (value != null && value.length == 10) || 'Preencha a data de início da suspensão'
                        ]"
                        color="blue-grey lighten-2"
                        autocomplete="disabled"
                        :name="Math.random()"
                        @keyup="dtInicioSuspensaoUS = valida_data_futura(dtInicioSuspensao) ? formatDateUS(dtInicioSuspensao) : null"
                        @change="validacao.suspensao_dtInicio = false"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dtInicioSuspensaoUS"
                      locale="pt-br"
                      no-title
                      @input="mnDtInicioSuspensao = false"
                      @change="validacao.suspensao_dtInicio = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs12 md6>
                  <v-menu v-model="mnDtFimSuspensao" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="dtFimSuspensao"
                        label="Data de Término"
                        v-mask="'##/##/####'"
                        hint="Obrigatório"
                        prepend-icon="event"
                        v-on="on"
                        :rules="[
                          validacao.suspensao_dtFim == false || validacao.suspensao_dtFim,
                          (value) => valida_data_futura(value) || 'Data inválida ou edição já fechada',
                          (value) => !!value || 'Obrigatório.',
                          (value) => (value != null && value.length == 10) || 'Preencha a data de término da suspensão'
                        ]"
                        color="blue-grey lighten-2"
                        autocomplete="disabled"
                        :name="Math.random()"
                        @keyup="dtFimSuspensaoUS = valida_data_futura(dtFimSuspensao) ? formatDateUS(dtFimSuspensao) : null"
                        @change="validacao.suspensao_dtFim = false"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="dtFimSuspensaoUS" locale="pt-br" no-title @input="mnDtFimSuspensao = false" @change="validacao.suspensao_dtFim = false"></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs12 md12>
                  <v-textarea
                    v-model="itemSuspender.motivo"
                    label="Motivo da Suspensão"
                    maxlength="255"
                    counter="255"
                    rows="3"
                    hint="Obrigatório"
                    :rules="[
                      validacao.suspensao_motivo == false || validacao.suspensao_motivo,
                      (value) => !!value || 'Obrigatório.',
                      (value) => (value != null && value.length >= 10 && value.length <= 255) || 'Texto do motivo da suspensão deve ter entre 10 e 255 caracteres'
                    ]"
                    color="blue-grey lighten-2"
                  ></v-textarea>
                </v-flex>

                <v-flex xs12>
                  <v-sheet class="ml-1 red--text" :value="true" v-if="validacao.suspensoes">{{ validacao.suspensoes }}</v-sheet>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="suspenderAssinatura">Agendar Suspensão</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" color="info" :timeout="5000" centered>{{ mensagem }}</v-snackbar>
    <v-snackbar v-model="snackErro" color="error" :timeout="5000" centered height="200">{{ mensagem }}</v-snackbar>
  </v-card>
</template>

<script>
import { api } from "@/services/api.js";
import util from "../util";
export default {
  data() {
    return {
      assinaturas: [],
      mensagemErro: "",

      validacao: {
        suspensoes: false,
        mensagemErro: false,
        suspensao_dtInicio: false,
        suspensao_dtFim: false,
        suspensao_motivo: false
      },

      dataInicio: null,
      itemCancelar: null,
      itemReativar: null,

      dialogOK: false,
      dialogConfirm: false,
      msgConfirm: "",

      dialogSuspender: false,
      suspensaoValid: true,
      itemSuspender: {
        idRenovacao: null,
        dtInicio: null,
        dtFim: null,
        motivo: ""
      },

      dtInicioSuspensao: null,
      dtInicioSuspensaoUS: null,
      mnDtInicioSuspensao: false,

      dtFimSuspensao: null,
      dtFimSuspensaoUS: null,
      mnDtFimSuspensao: false,

      snackbar: false,
      snackErro: false,
      mensagem: "",

      loading: true,
      semAssinaturas: false
    };
  },
  methods: {
    async carregarAssinaturas() {
      try {
        const response = await api.get("/ass/paywall/assinaturas");
        this.assinaturas = response.data;
        if (!this.assinaturas.length) {
          //* Usado para só mostrar a mensagem "você não possui assinaturas" após concluir o carregamento
          this.semAssinaturas = true;
        }
        for (let index = 0; index < this.assinaturas.length; index++) {
          const element = this.assinaturas[index];
          if (element.status == "PENDENTE") {
            this.mensagem = "Você possui uma assinatura PENDENTE - redirecionando para a tela de ativação...";
            this.snackErro = true;
            setTimeout(() => {
              this.$router.push("/ativar/" + element.id);
            }, 5000);
            break;
          }
          if (element.degustacao && !element.dtCancelamento) {
            //* Se tem período de degustação, permite cancelar enquanto estiver neste período
            var dtLimite = new Date();
            dtLimite.setDate(dtLimite.getDate() - parseInt(element.degustacao));
            var dtCriacao = util.parseDateUS(element.dtCriacao);
            if (dtLimite < dtCriacao) {
              element.cancelar = true;
            }
          }
        }
      } catch (e) {
        this.mensagemErro =
          "ERRO: " +
          (e.toString().includes("status code 400")
            ? "SESSÃO EXPIRADA"
            : e.response && e.response.data && e.response.data.length > 0
            ? e.response.data[0].mensagem
            : "Indeterminado, verifique sua conexão");
      } finally {
        this.loading = false;
      }
    },

    async confirmado() {
      if (this.itemCancelar) {
        await this.cancelarAssinatura();
      } else {
        this.reativarAssinatura();
      }
    },

    naoConfirmado() {
      this.itemCancelar = null;
      this.itemReativar = null;
      this.dialogConfirm = false;
    },

    cancela(item) {
      this.msgConfirm = "<p style='color:red'>Tem certeza que deseja CANCELAR esta assinatura?</p><p/>Você não poderá mais usufruir desta degustação!</p>";
      this.itemCancelar = item;
      this.dialogConfirm = true;
    },

    reativa(item) {
      this.msgConfirm =
        "<p style='color:red'>Tem certeza que deseja REATIVAR esta assinatura?</p><p/>Será necessário preencher dados do seu cartão de crédito para confirmar a operação.</p>";
      this.itemReativar = item;
      this.dialogConfirm = true;
    },

    async cancelarAssinatura() {
      if (this.itemCancelar.id) {
        try {
          await api.put("/ass/paywall/cancelar-assinatura/" + this.itemCancelar.id, this.itemCancelar);
          this.$router.push("/assinaturas");
          this.$router.go("/assinaturas");
        } catch (e) {
          this.mensagemErro =
            "ERRO: " +
            (e.toString().includes("status code 400")
              ? "SESSÃO EXPIRADA"
              : e.response && e.response.data && e.response.data.length > 0
              ? e.response.data[0].mensagem
              : "Indeterminado, verifique sua conexão");
        } finally {
          this.itemCancelar = null;
          this.dialogConfirm = false;
        }
      }
    },

    reativarAssinatura() {
      this.$router.push("/ativar/" + this.itemReativar.id + "?expirada=1");
    },

    async finalizarSuspensao(item) {
      try {
        if (item.dtSuspensao) {
          await api.put("/ass/paywall/finalizar-suspensao/" + item.id + (item.produtos.includes("IMPRESSO") ? "?impresso=1" : ""));
          this.$router.push("/assinaturas");
          this.$router.go("/assinaturas");
        }
      } catch (e) {
        this.mensagemErro =
          "ERRO: " +
          (e.toString().includes("status code 400")
            ? "SESSÃO EXPIRADA"
            : e.response && e.response.data && e.response.data.length > 0
            ? e.response.data[0].mensagem
            : "Indeterminado, verifique sua conexão");
      }
    },

    suspende(item) {
      this.itemSuspender = item;
      this.dialogSuspender = true;
    },

    async suspenderAssinatura() {
      if (this.itemSuspender.id) {
        await util.limparObjeto(this.validacao, false);
        if (!this.$refs.formSuspensao.validate()) {
          this.validacao.suspensoes = "Verifique os campos indicados em vermelho no formulário";
          return;
        }

        var erro = false;

        if (util.parseDateUS(this.dtFimSuspensaoUS) < util.parseDateUS(this.dtInicioSuspensaoUS)) {
          this.validacao.suspensao_dtFim = "Data de término não pode ser inferior a data de início";
          erro = true;
        }

        var dtLimite = new Date();
        dtLimite.setMonth(dtLimite.getMonth() + 3);
        if (util.parseDateUS(this.dtInicioSuspensaoUS) > dtLimite) {
          this.validacao.suspensao_dtInicio = "Data de início não pode ser superior a 3 meses";
          erro = true;
        }

        dtLimite = util.parseDateUS(this.dtInicioSuspensaoUS);
        dtLimite.setMonth(dtLimite.getMonth() + 3);
        if (util.parseDateUS(this.dtFimSuspensaoUS) > dtLimite) {
          this.validacao.suspensao_dtFim = "Período da suspensão não pode ser superior a 3 meses";
          erro = true;
        }

        if (erro) {
          this.validacao.suspensoes = "Verifique os campos indicados em vermelho no formulário";
          return;
        }

        const suspCommit = { idRenovacao: this.itemSuspender.idRenovacao, dtInicio: this.dtInicioSuspensaoUS, dtFim: this.dtFimSuspensaoUS, motivo: this.itemSuspender.motivo };

        try {
          await api.put("/ass/paywall/suspender-assinatura/" + this.itemSuspender.id, suspCommit);
          this.dialogSuspender = false;

          this.mensagem = "Suspensão registrada com sucesso!";
          this.snackbar = true;
          setTimeout(() => {
            this.$router.push("/assinaturas");
            this.$router.go("/assinaturas");
          }, 4000);
        } catch (e) {
          if (e.toString().includes("status code 400")) {
            this.validacao.mensagemErro = "SESSÃO EXPIRADA";
          } else if (e.response && e.response.data) {
            util.validaErros(this.validacao, e.response.data);
          } else {
            this.validacao.mensagemErro = "Ocorreu um erro indeterminado, verifique sua conexão";
          }
        }
      }
    },

    async calcularDtInicio() {
      try {
        const response = await api.get("/ass/paywall/data-fechamento");
        this.dataInicio = util.parseDateUS(response.data.dtInicio);
      } catch (e) {
        this.mensagemErro =
          "ERRO: " +
          (e.toString().includes("status code 400")
            ? "SESSÃO EXPIRADA"
            : e.response && e.response.data && e.response.data.length > 0
            ? e.response.data[0].mensagem
            : "Indeterminado, verifique sua conexão");
        setTimeout(() => {
          this.$router.push("/assinaturas");
          this.$router.go("/assinaturas");
        }, 2000);
      }
    },

    parseDateUS(date) {
      return util.parseDateUS(date);
    },
    formatDate(date) {
      return util.formatDate(date);
    },
    formatDateUS(date) {
      return util.formatDateUS(date);
    },
    valida_data_futura(date) {
      var retorno = false;
      if (date && date.length == 10) {
        var data = util.parseDate(date);
        if (data && data < this.dataInicio) {
          retorno = false;
        } else {
          retorno = true;
        }
      } else {
        retorno = true;
      }
      return retorno;
    },
    isCortesia(item) {
      return util.isFormaPgtoValorZero(item.formaPagamentoTipo);
    }
  },

  watch: {
    dtInicioSuspensaoUS() {
      this.dtInicioSuspensao = util.formatDate(this.dtInicioSuspensaoUS);
      this.mnDtInicioSuspensao = false;
    },
    dtFimSuspensaoUS() {
      this.dtFimSuspensao = util.formatDate(this.dtFimSuspensaoUS);
      this.mnDtFimSuspensao = false;
    }
  },

  async created() {
    do {
      await util.delay(1000);
    } while (!this.$store.state.site.enderecoSite);

    await this.calcularDtInicio();
    if (this.dataInicio) {
      await this.carregarAssinaturas();
      if (this.$route.path.includes("/assinaturas")) {
        document.title = this.$store.state.site.nome;
      }
      if (this.$route.path.includes("/assinaturas") && !this.$store.state.site.assinante) {
        this.$router.push("/assine");
        return;
      }
      if (!this.$store.state.login) {
        this.$router.push("/assine");
      } else if (this.$store.state.usuario.idDependente) {
        if (this.$store.state.site.flip) {
          this.$router.push("/newflip");
        } else {
          this.$router.push("/alterar-senha");
        }
      }
    }
  }
};
</script>

<style>
.dadoCampo {
  font-size: 15px;
}

.dadoValor {
  font-weight: 300;
  font-size: 18px;
}
</style>
